module.exports = __webpack_public_path__ + "static/img/empty1.e0112fbd.png";